import {
  AngleTool,
  AnnotationTool,
  ArrowAnnotateTool,
  BidirectionalTool,
  CircleROITool,
  CobbAngleTool,
  CrosshairsTool,
  EllipticalROITool,
  LengthTool,
  MagnifyTool,
  PanTool,
  PlanarFreehandROITool,
  ProbeTool,
  RectangleROITool,
  ReferenceLinesTool,
  StackScrollTool,
  WindowLevelTool,
  ZoomTool,
} from '@cornerstonejs/tools';
import Zoom from '../components/SVGComponents/Zoom';
import Viewer from '../pages/StudyViewer/Viewer';
import { isMobile } from 'react-device-detect';

export const AuthRoutes = {
  PATHOLOGY: '/pathology/list',
  EDITADMINUSER: '/user/edit',
  VIEWADMINUSER: '/user/view',
  ERRORCODE: '/errorList/list',
  MODALITY: '/modality/list',
  SUBMODALITY: '/sub-modality/list',
  ANNOTATION: '/annotation/list',
  ADDANNOTATION: '/master/add-annotation',
  VIEWANNOTATION: '/annotation/view',
  ERRORSTUDY: '/errorList/error',
  AUDITLOG: '/audit/logs',
  ISSUESANDTROUBLESHOOTING: '/issues-and-troubleshooting/setting',
  FIRMLIST: '/firm/list',
  CLIENTLIST: '/client/list',
  FIRMDETAILS: '/firm/view-firm',
  USERVIEW: '/user/view',
  ADDHOSPITAL: '/firm/add-hospital-client',
  ADDTELERADIOLOGYCENTRE: '/firm/add-trc',
  ADDIMAGINGCENTRE: '/firm/add-ic',
  EDITHOSPITAL: '/firm/edit',
  PROVIDERLIST: '/provider/list',
  PROVIDERVIEW: '/provider/view',

  SUPERVISORLIST: '/user/list-supervisor',
  //ADDSUPERVISOR: "/user/add-supervisor",
  MYADDSUPERVISOR: '/user/add-supervisor',
  FIRMDOCTORLIST: '/user/list-doctor',
  //ADDFIRMDOCTOR: "/user/add-doctor",
  MYADDFIRMDOCTOR: '/user/add-doctor',
  FIRMTECHNICIANLIST: '/user/list-user',
  //ADDFIRMTECHNICIAN: "/user/add-user",
  MYADDFIRMTECHNICIAN: '/user/add-user',
  ADMINRADIOLOGISTLIST: '/user/list-radiologist',
  RADIOLOGISTLIST: '/provider/list',
  //ADDRADIOLOGIST: "/user/add-radiologist",
  MYADDRADIOLOGIST: '/user/add-radiologist',
  ADMINUSERLIST: '/user/list-admin',
  //ADDADMINUSER: "/user/add-admin",
  MYADDADMINUSER: '/user/add-admin',
  FIRMADMINUSERLIST: '/user/list-firm-admin',
  //ADDFIRMADMINUSER: "/user/add-firm-admin",
  MYADDFIRMADMINUSER: '/user/add-firm-admin',
  //EDITUSER: "/user/edit",
  MYEDITUSER: '/user/edit',
  //VIEWUSER: "/user/view",
  MYVIEWUSER: '/user/view',
  HEADERTEMPLATE: '/firm/list/header/template',
  EDITHEADERTEMPLATE: '/firm/edit/header-template',
  CHANGEPWD: '/user/change-pwd',
  FORCECHANGEPWD: '/user/force-change-pwd',
  UPLOADSTUDY: '/upload/study',
  STUDYLIST: '/new/studylist',
  STUDYVIEWER: '/new/study/load/:studyId',
  NONXRAYADVANCEVIEWER: '/new/study/load/nonXrayAdvanceViewer/:studyId',
  PRIORSTUDYVIEWER: '/new/study/priors/load/:studyId',
  // STUDYVIEWER: "/study/load/:studyId",
  // PRIORSTUDYVIEWER: "/study/priors/load/:studyId",
  REPORT: 'patient/load/',
  EXPORTSTUDY: 'export/study',
  REPORTTEMPLATES: '/report/list/template/:tabId',
  ADDREPORTTEMPLATE: '/report/add/template/:tabId',
  EDITREPORTTEMPLATE: '/report/edit/template/:tabId',
  ACCOUNTANDSETTINGS: '/user/account-and-settings',
  ANALYTICS: '/analytics',
  SHOW_SHARED_REPORT: '/shared/report/view',
  ABOUT: '/about',
  BILLING: '/billing/detailed/sheet',
  BILLING_DATA_DOWNLOAD_FORM : '/new/billing/download-sheet-form',
  PING: '/ping',
  PRIVACY_POLICY: '/privacy-policy',
  SHAREDVIEWER: '/shared/study',
  MOBILEMORE: '/options',
  NOT_ALLOWED: '/not-allowed',
  REPORT_TEMPLATE: '/report/list/template/1',
  MY_STYLES:'/my-style/1',
  ADD_STYLE: '/styles/add/template/1',
  EDIT_STYLE: '/styles/edit/:styleId',
  TYPISTUSERLIST: "/user/list-typist",
  ADDTYPIST: "/user/add-typist",
  PACSQUEUELIST: "/pacs/queue/list",
  DOWNLOADTRIGGER: '/download/trigger',
  HANGINGPROTOCOLLIST: '/hangingprotocol/list',
  ADDHANGINGPROTOCOL: '/hangingprotocol/add',
  EDITHANGINGPROTOCOL: '/hangingprotocol/edit',
  VIEWHANGINGPROTOCOL: '/hangingprotocol/view',
  ADVLICENSE:"/adv/license/list",
  DOWNLOADTRIGGER: '/download/trigger'
};

export const NonAuthRoutes = {
  ROOT: '/',
  LOGIN: '/login',
  VIEWPDF: '/study/report/view/pdf/:studyId/:firmId',
  FORGOTPASSWORD: '/forgot-pwd',
  ENTEROTP: '/authenticate-otp',
  RESETPASSWORD: '/reset-pwd',
  CONTEXTSWITCHSTUDYLIST: '/open-api/loadStudyList',
  CONTEXTSWITCHSTUDYVIEWER: '/open-api/loadStudyViewer',
  TWOFACTORAUTHENTICATION: '/twofa-otp',
};

// export const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const API_BASE_URL =
  process.env.REACT_APP_HYBRID_MODE == 'true'
    ? window.location.origin + '/'
    : process.env.REACT_APP_BACKEND_BASE_URL;

export const DICOM_ACCEPTOR_BASE_URL = process.env.REACT_APP_DICOM_ACCEPTOR_BASE_URL;
export const ADVANCE_VIEWER_BASE_URL = process.env.REACT_ADVANCEVIEWER_BASE_URL;

export const SERVICEURL = 'jwtServices';

export const SHARED_SERVICEURL = 'sharedServices';

export const APIs = {
  ADMINUSERLIST: 'jwtServices/user-list',
  ADDADMINUSER: 'jwtServices/user-save',
  CHANGEUSERSTATUS: 'jwtServices/change-status/user',
  CHANGEUSERLOCKSTATUS: 'jwtServices/change-lock/user',
  PASSWORDRESET:'jwtServices/password-reset/admin',
  VIEWADMINUSER: 'jwtServices/user-view',
  EDITADMINUSER: 'jwtServices/user-update',
  LOADUSERDATA: 'jwtServices/load-by-username',
  ADDHOSPITAL: 'jwtServices/firm/add-new',
  EDITHOSPITAL: 'jwtServices/firm/save-edit-details',
  GETHEADERIMAGE: 'jwtServices/firm/get-header-image',
  GETFOOTERIMAGE: 'jwtServices/firm/get-footer-image',
  GETSIGNATUREIMAGE: 'jwtServices/firm/get-signature-image',
  MODALITYLIST: 'jwtServices/modality/list',
  SUBMODALITYLIST: 'jwtServices/sub-modality/list',
  SAVESUBMODALITY: 'jwtServices/sub-modality/save',
  EDITSUBMODALITY: 'jwtServices/sub-modality/edit',
  ERRORCODELIST: 'jwtServices/errorList/list',
  ERRORSEARCHLIST: 'jwtServices/errorList/search',
  ERRORSTUDYLIST: 'jwtServices/errorList/error',
  PATHALOGYLIST: 'jwtServices/pathology/list2',
  AUDITLOGSEARCH: 'jwtServices/audit/search',
  ORCHESTRATORSEARCH: 'jwtServices/orchestrator/search',
  ISSUESTATUSSEARCH : 'jwtServices/issuetracker/search',
  UPDATE_ISSUE_STATUS: 'jwtServices/issuetracker/update/status',
  UPDATE_ISSUE_STATUS_ALL: 'jwtServices/issuetracker/update/status/all',
  AUDITLOGSLIST: 'jwtServices/audit/logs',
  ORCHESTRATORLOGSLIST: 'jwtServices/orchestrator/logs',
  REDIRECTLOGOUT: '/',
  FIRMLIST: 'jwtServices/firm/list',
  PROVIDERLIST: 'jwtServices/provider-list',
  FIRMCHANGESTATUS: 'jwtServices/firm/change-status',
  VIEWFIRM: 'jwtServices/firm/view-firm',
  EDITFIRMSETTINGS: 'jwtServices/firm/edit-firm-settings',
  SAVEFIRMSETTINGS: 'jwtServices/firm/save-edit-firm-settings',
  ACITVATE_DEACTIVE: 'jwtServices/connection-process/activate-deactivate',
  CONNECTTOPROVIDER:
    'jwtServices/connection-process/create-connection/connect-to-provider',
  CONNECTTOCLIENT:
    'jwtServices/connection-process/create-connection/connect-to-client',
  CHANGEFIRMSTATUS: '/firm/change-status',
  USERLIST: 'jwtServices/user-list',
  NEWUSER: 'jwtServices/user-new',
  EDITUSER: 'jwtServices/user-edit',
  ADDUSER: 'jwtServices/user-save',
  VIEWUSER: 'jwtServices/user-view',
  UPDATEUSER: 'jwtServices/user-update',
  USERPROFILEUPDATE: "jwtServices/user-profile-update",
  SIGNATUREIMAGE: 'jwtServices/radiologist/api/get-signature-image',
  VIEWPROVIDER: 'jwtServices/provider-view',
  CHANGEPWD: 'jwtServices/user/changepwd',
  GETSTUDYLIST: '/studylist',
  GETPRIORSLIST: '/studylist/get/priors',
  GETPATIENTDATA: '/patient/get',
  GETSTUDYDATA: '/study/api/get',
  GETOPENAPISTUDYDATA: '/open-api-react/loadStudyViewer',
  GETPRIORSDATA: '/patient/get',
  GETIMAGEDATA: 'jwtServices/study/image/get/',
  GETIMAGEDATAWITHFILESIZE: 'jwtServices/study/imageWithFileSize/get/',
  GETPATIENTREPORT: 'jwtServices/study/report/get-patient-report',
  GETREPORTTEMPLATE: 'jwtServices/study/report/get-report-templates',
  DOWNLOADREPORT: 'jwtServices/study/report/download/',
  DOWNLOADAIREPORT: 'jwtServices/study/report/download/ai/pdf/',
  PREVIEWREPORT: 'jwtServices/study/report/preview/pdf/',
  PREVIEWREPORTVERSION: 'jwtServices/study/report/version/preview/pdf/',
  PREVIEWWORDREPORTHISTORY: "jwtServices/study/report/history/preview/pdf/",
  VIEWREPORT: '/study/report/view/pdf/',
  SAVEREPORT: 'jwtServices/study/report/save',
  SUBMITREPORT: 'jwtServices/study/report/submit',
  GETSTUDYREPORT: 'jwtServices/study/report/fetch',
  GETS10REPORT: 'jwtServices/study/report/fetchS10Report',
  GETALLPATHOLOGY: 'jwtServices/study/all-annotation-stuff',
  GETSELECTEDPATHOLOGY: 'jwtServices/study/selected-annotation-stuff',
  DOWNLOADSTUDYZIP: '/study/downloadStudy',
  DOWNLOADSTUDYPPT: '/study/downloadPpt',
  DOWNLOADSTUDYPPTASYNC: '/study/downloadPptAsync',
  ASSIGNSTUDY: '/study/assignme',
  REGENERATEREPORT: '/study/options/api/multiple-report-new-annotation',
  GENERATERSNAREPORT: '/study/options/api/smart-reporting',
  GETHTMLTEMPLATE: '/study/report/get-html-text',
  QCPASS: '/study/report/qcFail',
  QCPROVIDERLIST: '/studylist/getqcproviders',
  GENERATECTBRAIN: '/study/options/api/smart-report',
  GETHTMLTEMPLATE: '/study/report/get-html-text',
  HISTORYDOWNLOAD: '/study/history/download',
  LOGVIEWORIGINAL: '/study/logging',
  COMMUNICATIONDATA: '/feedback/fetch',
  SENDFEEDBACK: '/feedback/add',
  REPORTTEMPLATESLIST: 'jwtServices/report/list/template',
  REPORTTEMPLATESLISTBYTAB: '/report/templates/list',
  ADDREPORTTEMPLATE: 'jwtServices/report/add/save-template',
  EDITREPORTTEMPLATE: 'jwtServices/report/edit/template',
  EDITREPORTTEMPLATEAPI: 'jwtServices/report/edit/update-template',
  DELETEREPORTTEMPLATE: 'jwtServices/report/deleteReport',
  REPORTRADIOLOGIST: 'jwtServices/report/list/radiologist',
  STARTDOWNLOADSTUDYZIP: '/study/downloadStudyAsync',
  FETCHDOWNLOADPROGRESS: '/study/download/fetchProgress',
  DOWNLOADCOMPLETEDFILE: '/study/downloadFile',
  REPORTFIRMS: 'jwtServices/report/list/firm',
  REPORTCLIENTS: 'jwtServices/report/list/clients',
  GETHEADERTEMPLATE: 'jwtServices/firm/list/header/template',
  UPDATEDEFAULTHEADERTEMPLATE: 'jwtServices/firm/edit/default-template',
  EDITHEADERTEMPLATE: 'jwtServices/firm/edit/header-template',
  LISTFIRMHEADERTEMPLATE: 'jwtServices/firm/edit/hospital-header-template',
  USERPREFERENCE: 'jwtServices/user/preference',
  SAVEUSERPREFERENCE: 'jwtServices/user/savepreference',
  USERPROFILE: 'jwtServices/user/profile',
  AVAILABLESUPPORTMEMBERS: 'jwtServices/support-member/available',
  BARCHART: 'jwtServices/charts/bar/',
  PIECHART: 'jwtServices/charts/pie/',
  ANALYTICSDATA: 'jwtServices/charts/analytics',
  STUDYCOUNTS: 'jwtServices/charts/getstudycounts',
  CLIENTWARNINGSTATUS: 'jwtServices/firm/client-warning/status',
  GETUNASSIGNREASONCOUNT: '/unassignedReason',
  REFRESHTOKEN: 'auth/refreshToken',
  GETFISTOLUGRAM: 'jwtServices/study/getFistulogramPath',
  ADVANCEVIEWERSTATUS: '/study/advviewer/getstatus',
  DOWNLOADFISTOLUGRAM: '/study/downloadFistulogram',
  UPLOADFISTOLUGRAM: '/study/uploadFistulogram',
  GETSTUDYSTATUS: '/study/get-status',
  GETRETURNSTATUS: '/study/get-radiologist-return-status',
  SENDOLDSTUDYREQUEST: '/study/send-old-study-request',
  CHECKARCHIVEDSTUDYACCESSREQUEST: '/check-archived-study-access-request',
  SENDARCHIVEDSTUDYACCESSREQUEST: '/archived-study-access-request',
  ACCEPTSTUDYACCESSREQUEST: '/accept-study-access-request',
  REJECTSTUDYACCESSREQUEST: '/reject-study-access-request',
  SUPERVISORASSIGNME: '/study/supervisor/assignme',
  TYPISTASSIGNME: '/study/typist/assignme',
  TIMESPENDBYRADIOLOGIST: '/radiologist/timeSpent',
  GETMSWORDREPORTHISTORY: '/getReportHistory',
  FETCHUPLOADPROCESSSTATUS: '/study/upload/process-status/',
  MARKEDASSUSPECT: '/study/mark-as-suspected',
  GENERATEOTP: 'auth/generate-otp',
  GENERATEOTP2FA: 'auth/generate-otp-2fa',
  AUTHENTICATEOTP: 'auth/authenticate-otp',
  AUTHENTICA2FATEOTP: 'auth/authenticate-otp-2fa',
  RESETPASSWORD: 'auth/update-pwd',
  GETFIRMEMAIL: '/getfirmemail',
  GETFIRMDATAPRESENT: '/firm/share-report-link-enabled',
  GETPAYMENTSTATUS: '/vdc/study/get-payment-status',
  SENDREPORTTOLIMS: '/study/lims/send/report',
  ACTIVERADIOLOGISTVIEWING: '/radiologist/active',
  FIRMMODALITYLIST: '/firm/get-modality-list',
  DOWNLOADBILL: 'jwtServices/billing/detailed/sheet-download',
  DOWNLOADAUDITLOG: '/audit/csvexport',
  DOWNLOADORCHESTRATORLOG: '/orchestrator/csvexport',
  DOWNLOADERRORLISTLOG: '/errorList/csvexport',
  GETBILLINGHOSPITALLIST: 'jwtServices/billing/getHospitalList',
  AUTHENTICATEGOOGLEUSER: 'auth/authenticate-google-user',
  USERSETTINGS: '/user-settings',
  SUBMODALITYLISTNUMBERS: '/firm/get-sub-modality-list-numbers',
  DOWNLOADMANUAL: 'jwtServices/about-us/manual/download',
  PEERREVIEWDOWNLOAD:'/peer/review/download',
  GETSHAREDSTUDYDATA: '/study/get',
  GETSHAREDSTUDYADVACNEVIEWERURL: '/study/get/advanceViewerUrl',
  GETSHAREDIMAGEDATA: 'sharedServices/study/image/get/',
  GETMOBILESTUDYDATA: '/study/api/mobile/get',
  FETCHCSVDOWNLOADPROGRESS: '/studylist/csvexport/fetchProgress',
  DOWNLOADCOMPLETEDCSVFILE: '/studylist/csvexport/downloadFile',
  GETUPLOADSTUDYCLIENTS: '/getClient',
  GETUPLOADSTUDYINITIALDATA: '/uploadStudyList',
  STUDYINFORMATIONFROMPACS: '/vdc/study/pacs/information',
  PULLPACSSTUDYREPORT: '/vdc/study/report/pull',
  PUSHIMAGESTOPACS: '/vdc/study/image/push',
  GETWORDSESSION:"/study/report/get/word-session",
  OPENWORD: "ms-word/download/doc/",
  TYPISTADDSTUDY:"/typist/add-study",
  GETTYPISTDETAILS : "/typist-assignment-info",
  UNASSIGNTYPIST: "/unassign/typist",
  ECHOPACSNODE: 'jwtServices/echo/node',
  GETPACSNODE:"/study/get/nodes",
  SENDTOPACSNODE:"/study/send/to/nodes",
  GETRADIOLOGISTFORPEERREVIEW:"/peer/review/radiologist/list",
  GETEVALUATORS:"/peer/review/evaluator/list",
  ASSIGNFORPEERREVIEW:"/peer/review/radiologist/assign",
  ASSIGNFOREVALUATION:"/peer/review/evaluator/assign",
  BILLINGDATADOWNLOADEXCEL:"/api/download/billing/data1",
  SENDREPORTTOLIMS:"/study/lims/send/report",
  SENDTOPACSNODE:"/study/send/to/nodes",
  ADDREPORTTEMPLATERESTRICTIONS: "/report/template/restriction",
  MODALITYLISTFORRESTRICTION: "/report/template/modality/restriction",
  PACSQUEUELIST: 'jwtServices/pacs/queue/list',
  REFRESHQUEUEITEM: 'jwtServices/pacs/queue/item/refresh',
  CANCELQUEUEITEM: 'jwtServices/pacs/queue/item/cancel',
  SWAPQUEUEPRIORITY: 'jwtServices/pacs/queue/swapPriority',
  REFRESHQUEUEList: 'jwtServices/pacs/queue/list/refresh',
  GATEWAYSTUDYSTATUS: '/gateway/upload/status',
  SWITCHDATA: '/switchdata',
  DOWNLOADTRIGGER: '/download/trigger',
  REGENERATELLMREPORT: '/llmreport/regenerate',
  HP_GET_OPTIONS_LIST:'jwtServices/hangingprotocol/getoptionslist',
  HP_ADD:'jwtServices/hangingprotocol/add',
  HP_GET:'jwtServices/hangingprotocol/get',
  HP_GET_LIST:'jwtServices/hangingprotocol/hplist',
  HP_EDIT:'jwtServices/hangingprotocol/edit',
  HP_ACITVATE_DEACTIVE: 'jwtServices/hangingprotocol/updatestatus',
  HP_DETETE:'jwtServices/hangingprotocol/delete',
  ADVLICENSEUSERLIST: 'jwtServices/adv/license/list',
  ADVLICENSESAVE: 'jwtServices/adv/license/save',
  REGENERATELLMREPORT: '/llmreport/regenerate',
  GETFORMATTEDREPORT: '/study/report/formatted',
  SC_DICOM_UPLOAD : 'jwtServices/upload/sc-dicom',
  SUBMIT_STUDY_CLIPPING : 'jwtServices/submit-study-clipping',
  GETONLINERADIOLOGIST:'/radiologistanalytics/getOnlineRadiologist',
  SAVEMASKINGPROFILE: 'jwtServices/masking/profile/save',
  APPLYMASKINGPROFILE: 'jwtServices/masking/profile/apply',
  DELETEMASKINGPROFILE: 'jwtServices/masking/profile/delete',
  SETDEFAULTMASKINGPROFILE: 'jwtServices/masking/profile/default',
};

export const STORAGE_TYPE = {
  HOT_STORAGE: 1,
  COLD_STORAGE: 2,
};

export const LOGIN_FAILED_REASON = {
  LOCKED: 'LOCKED',
  INVALID: 'INVALID',
  ONE_ATTEMPT: 'ONE_ATTEMPT_REMAINING',
  TWO_ATTEMPTS: 'TWO_ATTEMPT_REMAINING',
  DEACTIVATED: "DEACTIVATED"
};

export const BASIC_VIEWER_URL = '/study/load/switch/'
export const ADVANCE_VIEWER_URL = "/study/load/nonXrayAdvanceViewer/"
export const REACT_ADVANCE_VIEWER_URL = "/new/study/load/nonXrayAdvanceViewer/"
export const BASIC_STUDYLIST = "/studylist"
export const ADVANCE_VIEWER_MODALITIES = ["CT", "MR", "MG", "ECG"]
export const HIDE_LOCK_ICON_TABS = ["qcfix"];
export const HIDE_ASSIGN_DROPDOWN_TABS = ["closed","qcfix","qcreview","qcverify"]
export const QC_TABS = ["qcreview","qcverify"];
export const QC_TABS_NAME = ["qcreview","qcverify","qcfix"];
export const SHOW_RETURNED_ROLES = ["ADMIN","FIRM_ADMIN","SUPERVISOR", "HOSPITAL_USER","HOSPITAL_DOCTOR"];
export const HIDE_ALERT_RAISE = ["HOSPITAL_USER","HOSPITAL_DOCTOR"]
export const SHOW_EXTERNAL_REPORTING_TO_USER = ["ADMIN","FIRM_ADMIN","RADIOLOGIST","TYPIST"]
export const HIDE_FILTER_FOR_ROLES = ["HOSPITAL_USER","HOSPITAL_DOCTOR","TYPIST"]
export const SHOW_SAVED_TAG_TABS = ["unreported","critical","library"];
export const NONXRAYMODALITIES = ["CR","DX"];

export const dicomBaseURL = API_BASE_URL.startsWith('https')
  ? API_BASE_URL.replace('https', 'wadouri') + APIs.GETIMAGEDATA
  : API_BASE_URL.replace('http', 'wadouri') + APIs.GETIMAGEDATA;

export const dicomWebURL = API_BASE_URL.startsWith('https')
? API_BASE_URL.replace('https', 'dicomweb') + APIs.GETIMAGEDATA
: API_BASE_URL.replace('http', 'dicomweb') + APIs.GETIMAGEDATA;  
// const dicomBaseURL = API_BASE_URL.startsWith("https")
//   ? API_BASE_URL.replace("https", "web") + APIs.GETIMAGEDATA
//   : API_BASE_URL.replace("http", "web") + APIs.GETIMAGEDATA;
export const imageBaseURL = API_BASE_URL.startsWith('https')
  ? API_BASE_URL.replace('https', 'web') + APIs.GETIMAGEDATA
  : API_BASE_URL.replace('http', 'web') + APIs.GETIMAGEDATA;

export const ACTIONS = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
};

export const USERTYPES = {
  FIRMADMIN: "FIRM_ADMIN",
  ADMIN: "ADMIN",
  SUPERVISOR: "SUPERVISOR",
  FIRMDOCTOR: "HOSPITAL_DOCTOR",
  FIRMTECHNICIAN: "HOSPITAL_USER",
  RADIOLOGIST: "RADIOLOGIST",
  TYPIST:"TYPIST"
};

export const TYPEOFUSER = {
  PROVIDER: 'Provider',
  RADIOLOGIST: 'Radiologist',
  CLIENT: 'Client',
};

export const REPORTSTATUS = [{ 1: 'Save' }, { 2: 'Submit' }];

export const REPORTDONESTATUS = {
  UNREPORTED: 0,
  SAVED: 1,
  REPORTED: 2,
  QC_REVIEW: 3,
  QC_FIX: 4,
  QC_VERIFY: 5,
  MARK_AS_SUSPECTED: 7,
};

export const RADIOLOGISTTYPE = ['Panel', 'Expert', 'Customer'];

export const BAR_CHART_COLORS = [
  'hsl(33, 80%, 76%)',
  'hsl(103, 77%, 74%)',
  'hsl(322, 85%, 80%)',
];

export const BAR_CHART_DOT_COLORS = [
  'hsl(33, 87%, 69%)',
  'hsl(103, 82%, 66%)',
  'hsl(348, 82%, 56%)',
];

export const PIE_CHART_COLORS = [
  'hsl(350, 70%, 50%)',
  'hsl(104, 70%, 50%)',
  'hsl(139, 70%, 50%)',
  'hsl(218, 70%, 50%)',
  'hsl(177, 70%, 50%)',
  'hsl(270, 70%, 50%)',
];

export const BAR_CHART_COLORS_ALLMODALITIES = 'hsl(238, 70%, 50%)';

export const VIEWPORT_ROW = 3;
export const VIEWPORT_COLUMN = 3;

export const TOOLS = [
  {
    key: StackScrollTool.toolName,
    NotFor: [],
    name: 'viewer.tools.stack-scroll',
    isEvent: true,
    eventName: 'EVENT_BASIC_STACK_SCROLL_TOOL_USED',
  },
  {
    key: WindowLevelTool.toolName,
    NotFor: [],
    name: 'viewer.tools.window',
    isEvent: true,
    eventName: 'EVENT_BASIC_WW_WL_TOOL_USED',
  },
  {
    key: ZoomTool.toolName,
    NotFor: [],
    name: 'viewer.tools.zoom',
    isEvent: true,
    eventName: 'EVENT_BASIC_ZOOM_TOOL_USED',
  },
  {
    key: PanTool.toolName,
    NotFor: [],
    name: 'viewer.tools.pan',
    isEvent: true,
    eventName: 'EVENT_BASIC_PAN_TOOL_USED',
  },
  {
    key: LengthTool.toolName,
    NotFor: [],
    //name: 'viewer.tools.length',
    name: 'viewer.tools.length-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_LENGTH_MEASUREMENT_TOOL_USED',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
    isEvent: true,
    eventName: 'EVENT_BASIC_BIDIRECTIONAL_MEASUREMENT_TOOL_USED',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    //name: 'viewer.tools.ellipse',
    name: 'viewer.tools.ellipse-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_ELLIPTICAL_ROI_TOOL_USED',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
    isEvent: true,
    eventName: 'EVENT_BASIC_RECTANGLE_ROI_TOOL_USED',
  },
];

export const MPR_TOOL_OBJECT = {
  key: 'MPR',
  NotFor: ['CR', 'DX', 'SR', 'RG', 'SC'],
  name: 'viewer.tools.mpr',
};

export const COMPARE_TOOL_OBJECT = {
  key: 'Compare',
  NotFor: [],
  name: 'viewer.tools.compare',
};

export const DROPDOWNTOOLS = [
  {
    key: 'Reset',
    NotFor: [],
    name: 'viewer.tools.reset',
    isEvent: true,
    eventName: 'EVENT_BASIC_RESET_TOOL_USED',
  },
  {
    key: 'Invert',
    NotFor: [],
    name: 'viewer.tools.invert',
    isEvent: true,
    eventName: 'EVENT_BASIC_INVERT_TOOL_USED',
  },
  {
    key: 'RotateRight',
    NotFor: [],
    name: 'viewer.tools.rotate-right',
    isEvent: true,
    eventName: 'EVENT_BASIC_ROTATE_TOOL_USED',
  },
  {
    key: 'RotateLeft',
    NotFor: [],
    name: 'viewer.tools.rotate-left',
    isEvent: true,
    eventName: 'EVENT_BASIC_ROTATE_TOOL_USED',
  },
  {
    key: 'FlipVertical',
    NotFor: [],
    name: 'viewer.tools.flipV',
    isEvent: true,
    eventName: 'EVENT_BASIC_VFLIP_TOOL_USED',
  },
  {
    key: 'FlipHorizontal',
    NotFor: [],
    name: 'viewer.tools.flipH',
    isEvent: true,
    eventName: 'EVENT_BASIC_HFLIP_TOOL_USED',
  },
  {
    key: ProbeTool.toolName,
    NotFor: [],
    name: 'viewer.tools.probe',
    isEvent: true,
    eventName: 'EVENT_BASIC_PIXEL_PROBE_TOOL_USED',
  },
  {
    key: ArrowAnnotateTool.toolName,
    NotFor: [],
    name: 'viewer.tools.annotation',
    isEvent: true,
    eventName: 'EVENT_BASIC_TEXT_TOOL_USED',
  },
  {
    key: ReferenceLinesTool.toolName,
    NotFor: ['CR', 'DX', 'US', 'SR', 'SC'],
    name: 'viewer.tools.reference',
    isEvent: true,
    eventName: 'EVENT_BASIC_REFERENCE_LINES_TOOL_USED',
  },
  {
    key: 'Synchronize',
    NotFor: ['CR', 'DX', 'US', 'SR', 'SC'],
    name: 'viewer.tools.synchronize',
    isEvent: true,
    eventName: 'EVENT_BASIC_SYNCHRONIZE_TOOL_USED',
  },
  {
    key: 'CINE',
    NotFor: [], //['CR', 'DX', 'US', 'SR', 'SC'],
    name: 'viewer.tools.cine',
    isEvent: true,
    eventName: 'EVENT_BASIC_PLAY_CLIP_TOOL_USED',
  },
  {
    key: AngleTool.toolName,
    NotFor: [],
    name: 'viewer.tools.angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_ANGLE_MEASUREMENT_TOOL_USED',
  },
  {
    key: CobbAngleTool.toolName,
    NotFor: [],
    name: 'viewer.tools.cobb-angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_COBB_ANGLE_MEASUREMENT_TOOL_USED',
  },
  {
    key: MagnifyTool.toolName,
    NotFor: [],
    name: 'viewer.tools.magnify',
    isEvent: true,
    eventName: 'EVENT_BASIC_MAGNIFY_TOOL_USED',
  },
  {
    key: PlanarFreehandROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.planarfreehandroi',
    isEvent: true,
    eventName: 'EVENT_BASIC_PLANARFREEHAND_ROI_TOOL_USED',
  },
  {
    key: CircleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.circleroi',
    isEvent: true,
    eventName: 'EVENT_BASIC_CIRCLE_ROI_TOOL_USED',
  },
  {
    key: PanTool.toolName,
    NotFor: [],
    name: 'viewer.tools.pan',
    isEvent: true,
    eventName: 'EVENT_BASIC_PAN_TOOL_USED',
  },
  {
    key: LengthTool.toolName,
    NotFor: [],
    name: 'viewer.tools.length-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_LENGTH_MEASUREMENT_TOOL_USED',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_BIDIRECTIONAL_MEASUREMENT_TOOL_USED',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.ellipse-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ELLIPTICAL_ROI_TOOL_USED',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_RECTANGLE_ROI_TOOL_USED',
  },
 
];

export const PASSIVE_TOOLs = [
  LengthTool.toolName,
  BidirectionalTool.toolName,
  EllipticalROITool.toolName,
  PanTool.toolName,
  ProbeTool.toolName,
  RectangleROITool.toolName,
  ArrowAnnotateTool.toolName,
  AngleTool.toolName,
  CobbAngleTool.toolName,
  PlanarFreehandROITool.toolName,
  CircleROITool.toolName,
];

export const VIEWPORT_TOOLS = [
  'Invert',
  'RotateRight',
  'RotateLeft',
  'FlipVertical',
  'FlipHorizontal',
  'Reset',
  'CINE',
  'Synchronize',
  'ReferenceLines',
];

export const HIDE_TOOL_SMALL_SCREEN = [
  EllipticalROITool.toolName,
  BidirectionalTool.toolName,
  RectangleROITool.toolName,
  LengthTool.toolName,
  PanTool.toolName
];

export const MPR_TOOLS = [
  {
    key: StackScrollTool.toolName,
    name: 'viewer.tools.stack-scroll',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_STACK_SCROLL_TOOL_USED',
  },
  {
    key: ZoomTool.toolName,
    name: 'viewer.tools.zoom',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ZOOM_TOOL_USED',
  },
  {
    key: WindowLevelTool.toolName,
    name: 'viewer.tools.window',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_WW_WL_TOOL_USED',
  },
  {
    key: PanTool.toolName,
    name: 'viewer.tools.pan',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PAN_TOOL_USED',
  },
  {
    key: CrosshairsTool.toolName,
    name: 'viewer.tools.crosshairs',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_CROSSHAIRS_TOOL_USED',
  },
  {
    key: ReferenceLinesTool.toolName,
    name: 'viewer.tools.reference',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_REFERENCE_LINES_TOOL_USED',
  },
  {
    key: LengthTool.toolName,
    //name: 'viewer.tools.length',
    name: 'viewer.tools.length-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_LENGTH_MEASUREMENT_TOOL_USED',
  },
  {
    key: BidirectionalTool.toolName,
    name: 'viewer.tools.bidirectional',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_BIDIRECTIONAL_MEASUREMENT_TOOL_USED',
  },
  {
    key: EllipticalROITool.toolName,
    //name: 'viewer.tools.ellipse',
    name: 'viewer.tools.ellipse-with-shortcut-key',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ELLIPTICAL_ROI_TOOL_USED',
  },
  {
    key: RectangleROITool.toolName,
    name: 'viewer.tools.rectangle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_RECTANGLE_ROI_TOOL_USED',
  },
  {
    key: ProbeTool.toolName,
    name: 'viewer.tools.probe',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PIXEL_PROBE_TOOL_USED',
  },
  {
    key: ArrowAnnotateTool.toolName,
    name: 'viewer.tools.annotation',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_TEXT_TOOL_USED',
  },
  {
    key: 'CINE',
    NotFor: ['CR', 'DX', 'US', 'SR'],
    name: 'viewer.tools.cine',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_PLAY_CLIP_TOOL_USED',
  },
  {
    key: AngleTool.toolName,
    name: 'viewer.tools.angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_ANGLE_TOOL_USED',
  },
  {
    key: CobbAngleTool.toolName,
    name: 'viewer.tools.cobb-angle',
    isEvent: true,
    eventName: 'EVENT_BASIC_MPR_COBB_ANGLE_TOOL_USED',
  },
];

export const DEFAULT_TOOL = WindowLevelTool.toolName;
export const XRAY_DEFAULT_TOOL = WindowLevelTool.toolName;

export const LATERAL_VIEW_MODALITY_LIST = ['CT', 'MR'];
export const WINDOW_LEVEL_MODALITY_LIST = ['CT'];

export const SHOW_NOT_ORIGNAL_MODALITY_LIST = ['CT', 'MR'];
export const SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST = ['DX', 'CR', 'SC'];
export const CONSTRUCTABLE_MODALITIES = ['MR', 'CT', 'PT', 'NM'];
export const WINDOW_LEVEL_PRESETS = [
  {
    key: 'Abdomen (Press 1)',
    ww: 400,
    wc: 60,
    edge: false,
  },
  {
    key: 'Angio (Press 2)',
    ww: 600,
    wc: 300,
    edge: false,
  },
  {
    key: 'Bone (Press 3)',
    ww: 1500,
    wc: 300,
    edge: true,
  },
  {
    key: 'Brain (Press 4)',
    ww: 80,
    wc: 40,
    edge: false,
  },
  {
    key: 'Chest (Press 5)',
    ww: 400,
    wc: 40,
    edge: false,
  },
  {
    key: 'Lungs (Press 6)',
    ww: 1500,
    wc: -400,
    edge: true,
  },
  {
    key: 'Cerebrum (Press 7)',
    ww: 120,
    wc: 40,
    edge: false,
  },
  {
    key: 'Liver (Press 8)',
    ww: 150,
    wc: 50,
    edge: false,
  },
  {
    key: 'Mediastinum (Press 9)',
    ww: 300,
    wc: 50,
    edge: false,
  },
  {
    key: 'Pelvis',
    ww: 400,
    wc: 40,
    edge: false,
  },
  {
    key: 'Posterior Fossa',
    ww: 250,
    wc: 80,
    edge: false,
  },
  {
    key: 'Soft Tissue',
    ww: 400,
    wc: 40,
    edge: false,
  },
];

export const STUDY_DOWNLOAD_OPTIONS = [
  'Download Study',
  'Download PPT',
  'Download Images',
];

export const COLORS = {
  warning: '#F9B403',
};

export const CT_VALIDATION_MESSAGE = {
  _iMessageCtBrainSelectOptionAndWidthFromDimension:
    'Please select an option for the provided dimensions and also enter the width.',
  _iMessageCtBrainSelectOptionAndHeightFromDimension:
    'Please select an option for the provided dimensions and also enter the height.',
  _iMessageCtBrainErrorBleedRightDimensions:
    'Please enter the height and width for bleed right.',
  _iMessageCtBrainErrorBleedRightHeight:
    'Please enter the height for bleed right.',
  _iMessageCtBrainErrorBleedRightWidth:
    'Please enter the width for bleed right.',
  _iMessageCtBrainErrorBleedLeftDimensions:
    'Please enter the height and width for bleed left.',
  _iMessageCtBrainErrorBleedLeftHeight:
    'Please enter the height for bleed left.',
  _iMessageCtBrainErrorBleedLeftWidth: 'Please enter the width for bleed left.',
  _iMessageCtBrainErrorHemorrhagicRightDimensions:
    'Please enter the height and width for hemorrhagic contusion right.',
  _iMessageCtBrainErrorHemorrhagicRightHeight:
    'Please enter the height for hemorrhagic contusion right.',
  _iMessageCtBrainErrorHemorrhagicRightWidth:
    'Please enter the width for hemorrhagic contusion right.',
  _iMessageCtBrainErrorHemorrhagicLeftDimensions:
    'Please enter the height and width for hemorrhagic contusion left.',
  _iMessageCtBrainErrorHemorrhagicLeftHeight:
    'Please enter the height for hemorrhagic contusion left.',
  _iMessageCtBrainErrorHemorrhagicLeftWidth:
    'Please enter the width for hemorrhagic contusion left.',
  _iMessageCtBrainErrorEpiduralRightDimensions:
    'Please enter the height and width for epidural hematoma right.',
  _iMessageCtBrainErrorEpiduralRightHeight:
    'Please enter the height for epidural hematoma right.',
  _iMessageCtBrainErrorEpiduralRightWidth:
    'Please enter the width for epidural hematoma right.',
  _iMessageCtBrainErrorEpiduralLeftDimensions:
    'Please enter the height and width for epidural hematoma left.',
  _iMessageCtBrainErrorEpiduralLeftHeight:
    'Please enter the height for epidural hematoma left.',
  _iMessageCtBrainErrorEpiduralLeftWidth:
    'Please enter the width for epidural hematoma left.',
  _iMessageCtBrainErrorSubduralRightDimensions:
    'Please enter the height and width for subdural hematoma right.',
  _iMessageCtBrainErrorSubduralRightHeight:
    'Please enter the height for subdural hematoma right.',
  _iMessageCtBrainErrorSubduralRightWidth:
    'Please enter the width for subdural hematoma right.',
  _iMessageCtBrainErrorSubduralLeftDimensions:
    'Please enter the height and width for subdural hematoma left.',
  _iMessageCtBrainErrorSubduralLeftHeight:
    'Please enter the height for subdural hematoma left.',
  _iMessageCtBrainErrorSubduralLeftWidth:
    'Please enter the width for subdural hematoma left.',
  _iMessageCovidSrAdditionalFinding:
    'No focal or diffuse pathology in the visualized areas of the upper abdomen.',
};

export const COVID_SR_MESSAGE = {
  _iMessageCovidMild: 'Mild',
  _iMessageCovidModerate: 'Moderate',
  _iMessageCovidSevere: 'Severe',
  _iMessageCovidSectionAFinding:
    'Rest of the lung parenchyma is normal. No nodules or mass seen.',
  _iMessageCovidClinicalHistoryOtherError:
    'Please enter the clinical history comment.',
  _iMessageCovidOptionsNotSelectedError:
    'Please select at least one zone for the selection in section A.',
  _iMessageCovidReverseHaloSignError:
    'Please select present or absent option for reverse halo sign.',
  _iMessageCovidSectionError: 'Please select either section A or section B.',
  _iMessageCovidCoradsError: 'Please select the applicable corads option.',
};

export const VALIDATE_SPINE = {
  _imessageSelectEitherScolosisLumbarOrScolasisThoracolumbar:
    'Select either Scolosis Lumbar or Scolasis Thoracolumbar',
  _imessageSelectEitherAbnormalSclerosedOrAbnormalErosion:
    'Select either Abnormal Sclerosed or Abnormal Erosion',
  _imessageLumbarSpineFractureShouldBeWithSpineOrLumbarWithObliquesOrLumbarWithFlexionAndExtension:
    'Lumbar Spine Fracture should be used with Spine or Lumbar With Obliques or Lumbar With Flexion and Extension',
  _imessageSelectApplicableSuboptionFromLysisLevel:
    'Select applicable suboption from Lysis->Level',
  _imessageListhesisCanNotBeAbsent: 'Listhesis can not be absent',
  _imessageAbsentOptionCannotBeUsedWithLysisListhesisMildModerateSevere:
    'Absent option cannot be used with Lysis->Listhesis Mild/Moderate/Severe',
  _imessageSelectOnlyOneOptionFromLysisListhesisMildModerateSevere:
    'Select only one option from Lysis->Listhesis Mild/Moderate/Severe',
  _iPleaseSelect: 'Please select',
  _iOnlyOnceFrom: 'only once from',
  _iOr: 'or',
  _iselectOneTechnique: 'Select one technique at a time',
};

export const GENERAL_FRACTURE_VALIDATION = {
  _iselectOptionOrRemoveAnnotation:
    'Please select option/suboption or remove General Fracture annotation',
  _ienterPlasterLocation: 'Please enter Plaster-Location details',
  _iselectOneFromPlaster: 'Please select one value from Plaster-Area',
  _iselectOneFromCastOrSlab:
    'Please select one option from Plaster-cast/slab or nil',
  _iUnselectDisplacemetNil: 'Please unselect General Fracture-Displacement-Nil',
  _iselectOneFromAvulusionFracture:
    'Please select only one option small or large from  General Fracture-Displacement-Avulusion Fracture',
  _iselectEitherUndisplacedOrMinimalOrSignificant:
    'lease select either Undisplaced or Minimally displaced or Significantly displaced from  General Fracture-Displacement-Avulusion Fracture',
  _iUnselectTypeNil: 'Please unselect General Fracture-Type-Nil',
  _iUnselectFragmentNil: 'Please unselect General Fracture-Fragments-Nil',
  _iUnselectFragmentAligned:
    'Please unselect General Fracture-Fragments-Aligned',
  _iselectWithOrWithoutIAE:
    'Please select with or without intra articular extension from General Fracture-Fragments',
  _iUnselectAbsentFromCallus:
    'Please unselect Absent from General Fracture-Callus',
  _iUnselectNilAssociatedFindings:
    'Please unselect Nil option from General Fracture-Associated Findings',
  _iUnselectNilImplants:
    'Please unselect Nil option from General Fracture-Implants',
  _iUnselectNilSoftTissue:
    'Please unselect Nil option from General Fracture-Soft Tissue',
};

export const COVID_SUSPECT_VALIDATION = {
  _iOneCovidTtemplate: 'Please select one COVID template.',
  _iOneOptionCVCX1: 'Please select one option from CVCX1.',
  _iOneSuboptionCVCX2:
    'Please select one suboption from Severity and Location from CVCX2',
  _iOneOptionCVCX3Pneumothorax:
    'Please select one option from CVCX3->Mild/Moderate/Severe Pneumothorax.',
  _iOneOptionCVCX3PleuralEffusion:
    'Please select one option from CVCX3->Mild/Moderate/Severe Pleural Effusion',
};

export const MRI_SPINE_VALIDATION_MSG = {
  _iMessageOtherClinicalProfileError:
    'Please enter the other clinical profile details.',
  _iMessageOtherSuggestedImpressionError:
    'Please enter the other suggested impression.',
};

export const RSNA_VALIDATION_MSG = {
  _iMessageRsnaClinicalHistoryError:
    'Please enter the comment for clinical history.',
  _iMessageRsnaLimitationError: 'Please enter the comment for limitation.',
  _iMessageRsnaFindingSelectionError:
    'No findings are selected. Select findings to proceed.',
};

export const REPORT_TITLE = {
  TUBERCULOSIS: 'TUBERCULOSIS',
  HRCT_CHEST_ILD: 'HRCT CHEST ILD',
  HRCT_CHEST_COVID: 'HRCT CHEST TO EXCLUDE/DIAGNOSE COVID-19',
  CT_BRAIN: 'CT BRAIN SR',
  HRCT_CHEST_COVID_SR: 'HRCT CHEST COVID SR',
  MRI_SPINE_SR: 'MRI SPINE SR',
};


export const THUMBNAIL_FETCH_SIZE = isMobile ? 1 : 50;
export const THUMBNAIL_BATCH_SIZE = 5;

export const VIEWER_PROGRESS_STATE = {
  API: 10,
  TRANSFORM: 10,
  THUMBNAIL: 70,
  VIEWPORT: 100,
};

export const TOAST_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  BATCHASSIGN: 'batchAssign',
  SUSPECT: 'suspect',
};

export const STACK_SCROLL_DROPDOWN_ELEMENTS = [
  { key: 'Go to Previous Series' },
  { key: 'Go to Next Series' },
];

export const MOBILE_TOOLS = [
  {
    key: StackScrollTool.toolName,
    NotFor: [],
    name: 'viewer.tools.stack-scroll',
  },
  {
    key: WindowLevelTool.toolName,
    NotFor: [],
    name: 'viewer.tools.window',
  },
  {
    key: ZoomTool.toolName,
    NotFor: [],
    name: 'viewer.tools.zoom',
  },
  {
    key: PanTool.toolName,
    NotFor: [],
    name: 'viewer.tools.pan',
  },
  {
    key: LengthTool.toolName,
    NotFor: [],
    name: 'viewer.tools.length',
  },
  {
    key: BidirectionalTool.toolName,
    NotFor: [],
    name: 'viewer.tools.bidirectional',
  },
  {
    key: EllipticalROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.ellipse',
  },
  {
    key: RectangleROITool.toolName,
    NotFor: [],
    name: 'viewer.tools.rectangle',
  },
  {
    key: 'Reset',
    NotFor: [],
    name: 'viewer.tools.reset',
  },
  {
    key: 'Invert',
    NotFor: [],
    name: 'viewer.tools.invert',
  },
  {
    key: 'RotateRight',
    NotFor: [],
    name: 'viewer.tools.rotate-right',
  },
  {
    key: 'RotateLeft',
    NotFor: [],
    name: 'viewer.tools.rotate-left',
  },
  {
    key: 'FlipVertical',
    NotFor: [],
    name: 'viewer.tools.flipV',
  },
  {
    key: 'FlipHorizontal',
    NotFor: [],
    name: 'viewer.tools.flipH',
  },
  {
    key: ProbeTool.toolName,
    NotFor: [],
    name: 'viewer.tools.probe',
  },
  {
    key: ArrowAnnotateTool.toolName,
    NotFor: [],
    name: 'viewer.tools.annotation',
  },
  {
    key: 'CINE',
    NotFor: ['CR', 'DX', 'US', 'SR'],
    name: 'viewer.tools.cine',
  },
];

export const widthOfColumns = (role) => {
  if (role == USERTYPES.ADMIN) {
    return {
      selectColumn: '4%',
      patientColumn: '11%',
      studyColumn: '14%',
      clientColumn: '14%',
      radiologistColumn: '16%',
      reportColumn: '10%',
      actionColumn: '10%',
      triageColumn: '10%',
    };
  }
  if (role == USERTYPES.FIRMADMIN || role == USERTYPES.SUPERVISOR) {
    return {
      selectColumn: '4%',
      patientColumn: '11%',
      studyColumn: '15%',
      clientColumn: '11%',
      qcColumn: '13%',
      radiologistColumn: '18%',
      reportColumn: '10%',
      actionColumn: '10%',
      triageColumn: '10%',
      requestDetailsColumn: '20%',
    };
  } else if (role == USERTYPES.RADIOLOGIST) {
    return {
      selectColumn: '3%',
      patientColumn: '15%',
      studyColumn: '15%',
      radiologistColumn: '15%',
      reportColumn: '15%',
      actionColumn: '10%',
      triageColumn: '15%',
    };
  } else {
    return {
      selectColumn: '3%',
      patientColumn: '13%',
      studyColumn: '15%',
      clientColumn: '11%',
      radiologistColumn: '16%',
      reportColumn: '10%',
      actionColumn: '6%',
      triageColumn: '10%',
    };
  }
};

export const showPathologyForModalities = ['DX', 'CR', 'RG', 'SC'];
export const ECG = 'ECG';

export const modalityRowBadgeColor = (modality) => {
  switch (modality) {
    case 'CT':
      return { background: '#E37475', color: '#FFFFFF' };
    case 'DX':
      return { background: '#6DA370', color: '#FFFFFF' };
    case 'CR':
      return { background: '#5B9BCD', color: '#FFFFFF' };
    case 'MRI':
      return { background: '#B99A40', color: '#FFFFFF' };
    case 'MR':
      return { background: '#5627A4', color: '#FFFFFF' };
    case 'US':
      return { background: '#C4664C', color: '#FFFFFF' };
    case 'NM':
      return { background: '#73A53A', color: '#FFFFFF' };
    case 'MG':
      return { background: '#BC8E44', color: '#FFFFFF' };
    case 'OT':
      return { background: '#BF4E84', color: '#FFFFFF' };
    case 'PT':
      return { background: '#ABB44D', color: '#FFFFFF' };
    case 'SR':
      return { background: '#B18A4E', color: '#FFFFFF' };
    default:
      return { background: '#A64B4B', color: '#FFFFFF' };
  }
};

export const REPORT_DONE_STATUS = {
  UNREPORTED: 0,
  SAVED: 1,
  REPORTED: 2,
  QCREVIEW: 3,
  QCFIX: 4,
  QCVERIFY: 5,
  MARK_AS_SUSPECTED: 7,
};

export const TAB_NAME = {
  UNREPORTED: 'unreported',
  SAVED: 'saved',
  REPORTED: 'reported',
  CLOSED: 'closed',
  QCREVIEW: 'qcreview',
  QCFIX: 'qcfix',
  QCVERIFY: 'qcverify',
  RETURNED: 'returned',
  CRITICAL: 'critical',
  LIBRARY: 'library',
  NORMAL: 'normal',
  NORMALWITHFB: 'normalwithfb',
  ABNORMAL: 'abnormal',
  PEERREVIEW: 'peerReview',
  REVIEWASSIGNED: 'reviewAssigned',
  REVIEWCOMPLETE: 'reviewComplete',
  EVALUATIONASSIGNED: 'evaluationAssigned',
  EVALUATIONCOMPLETE: 'evaluationComplete',
  PENDING:'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVIEWPENDING: 'reviewPending'
};

export const DEFAULT_SORT_COLUMNS = new Set([
  "assignment_created_date",
  "report_submitted_date",
  "review_assigned_date",
  "review_completed_date",
  "evaluation_assigned_date",
  "evaluation_completion_date",
  "requested_date",
  "approved_date",
  "requested_date2",
]);

export const FILTER_TYPE = {
  ModalityList: 'modalityList',
  ClientFirmList: 'clientFirmList',
  AnnotationList: 'annotationList',
  ClassificationList:'classificationList',
  PriorityList: 'priorityList',
  RadiologistList: 'radiologistList',
  AssignmentDateRange: "assignmentDateRange",
};

export const CXR_TABS = {
  unreported: 'Unreported',
  normal: 'CXR: No Suspicions',
  normalWithFB: 'CXR: FO Only',
  abnormal: 'CXR: With Suspicions',
};

export const PEER_REVIEW_TABS = {
  reviewAssigned: 'Review Assigned',
  reviewComplete: 'Review Complete',
  evaluationAssigned: 'Evaluation Assigned',
  evaluationComplete: 'Evaluation Complete',
};

export const CXR_TABS_NAME = [
  'unreported',
  'normal',
  'normalwithfb',
  'abnormal',
];

export const PEER_REVIEW_TABS_NAME = [
  'reviewAssigned',
  'reviewComplete',
  'evaluationAssigned',
  'evaluationComplete',
];

export const ARCHIVED_STUDY_TABS = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};

export const ARCHIVED_STUDY_TABS_NAME = [
  'pending',
  'approved',
  'rejected',
];

export const SAVED_TABS = {
  saved: 'All Studies',
  reviewPending: 'Review Pending',
};

export const SAVED_TABS_NAME = [
  'saved',
  'reviewPending',
];

export const CXR_SUBTABS_ID = ['study_1', 'study_11', 'study_12', 'study_13'];
export const PEER_REVIEW_SUBTABS_ID = ['study_14', 'study_15', 'study_16', 'study_17'];
export const ARCHIVED_ACCESS_SUBTABS_ID = ['study_18', 'study_19', 'study_20'];
export const SAVED_SUBTABS_ID = ['study_2', 'study_21'];

export const CXR_TABS_ALLOWED_ROLES = [
  USERTYPES.ADMIN,
  USERTYPES.FIRMADMIN,
  USERTYPES.SUPERVISOR,
  USERTYPES.RADIOLOGIST,
];

export const PEER_REVIEW_TABS_ALLOWED_ROLES = [
  USERTYPES.ADMIN,
  USERTYPES.FIRMADMIN,
  USERTYPES.SUPERVISOR,
  USERTYPES.RADIOLOGIST,
];

export const ARCHIVED_STUDY_ACCESS_TABS_ALLOWED_ROLES = [
  USERTYPES.FIRMADMIN,
];

export const SAVED_TABS_ALLOWED_ROLES = [
  USERTYPES.RADIOLOGIST,
  USERTYPES.FIRMADMIN,
  USERTYPES.SUPERVISOR,
];

export const VDCLIMS = {
  DUE: 'DUE',
  PAID: 'PAID',
  ERROR: 'ERROR',
  PaymentStatusCodes: {
    DUE: 0,
    PAID: 1,
    ERROR: 2,
  },
  paymentStatusCodesToString: (code) => {
    if (code == 0) return VDCLIMS.DUE;
    else if (code == 1) return VDCLIMS.PAID;
    return VDCLIMS.ERROR;
  },
  PAYMENT_STATUS_IS_NOT_CLEAR: 'Payment status is not clear',
  PAYMENT_MESSAGE_FOR_ERROR:
    'Unable to perform action - Reason:  Error fetching payment data.',
  PAYMENT_MESSAGE_FOR_DUE:
    'Unable to perform action - Reason: Payment for this study is not complete.',
};

export const BADGE_INFO_OBJ = {
  MORE_THAN_2_HR: {
    COLOR_NAME: 'morethan2hr',
    BACKGROUND: 'rgba(243, 113, 113, 0.45)',
    TEXT_COLOR: 'rgb(233 19 19)',
  },
  SAVED: {
    BACKGROUND: '#CEF29F',
    TEXT_COLOR: '#004F32',
  },
  LESS_THAN_1_HR: {
    COLOR_NAME: 'lessthan1hr',
    BACKGROUND: 'rgba(217, 82, 234, 0.22)',
    TEXT_COLOR: 'rgb(180 40 198)',
  },
  LESS_THAN_2_HR: {
    COLOR_NAME: 'lessthan2hr',
    BACKGROUND: '#ffa500',
    TEXT_COLOR: '#7c5b1e',
  },
  MORE_THAN_24_HR: {
    COLOR_NAME: 'morethan24hr',
    BACKGROUND: 'rgb(193 46 13)',
    TEXT_COLOR: 'white',
  },
  QC_REVIEW_PENDING: {
    BACKGROUND: 'rgb(126, 85, 239)',
    TEXT_COLOR: 'white',
  },
  QC_FIX_PENDING: {
    BACKGROUND: 'rgb(176, 167, 43)',
    TEXT_COLOR: 'white',
  },
  QC_VERIFICATION_PENDING: {
    BACKGROUND: 'rgb(63, 120, 72)',
    TEXT_COLOR: 'white',
  },
  REPORTED: {
    BACKGROUND: 'rgba(84, 136, 202, 0.51)',
    TEXT_COLOR: 'rgb(0 61 139)',
  },
  RESUBMITTED: {
    BACKGROUND: '#CEF29F',
    TEXT_COLOR: '#033701',
  },
  TAT_LESS_THAN_1_HR: {
    COLOR_NAME: 'TATlessthan1hour',
    BACKGROUND: 'rgba(126, 248, 6, 0.21)',
    TEXT_COLOR: 'white',
  },
  TAT_MORE_THAN_12_HR: {
    COLOR_NAME: 'TATmorethan12hours',
    BACKGROUND: 'rgba(209, 21, 21, 0.24)',
    TEXT_COLOR: 'white',
  },
  TAT_BETWEEN_1_TO_2_HR: {
    COLOR_NAME: 'TATbetween1to2hours',
    BACKGROUND: 'rgba(255, 235, 59, 0.51)',
    TEXT_COLOR: 'white',
  },
  TAT_BETWEEN_2_TO_3_HR: {
    COLOR_NAME: 'TATbewteen2to3hours',
    BACKGROUND: 'rgba(227, 140, 51, 0.43)',
    TEXT_COLOR: 'white',
  },
  TAT_BETWEEN_3_TO_12_HR: {
    COLOR_NAME: 'TATbetween3to12hours',
    BACKGROUND: 'rgba(208, 13, 241, 0.23)',
    TEXT_COLOR: 'white',
  },
};

export const BADGE_COLOR_NAME = {
  LESS_THAN_1_HR: 'lessthan1hr',
};

export const BORDER = {
  TAB: '1px solid #585858',
};

export const SELECTED_TAB_KEY = {
  TROUBLESHOOTING: 'trouble_',
  REPORTTEMPLATE: 'report_',
  UPLOADSTUDY: 'uploadStudy_',
  PACSQUEUE:'pacQueue_',
};

export const CUSTOM_STYLES = {
  ACTIVE_TAB: '1px solid #585858',
  STUDYLIST_TD_TOP_MARGIN: '15px',
  MODAL_BORDER: '1px solid #585858',
};

export const MODAL_TYPE = {
  AVAILABLE_NOW: 'AVAILABLE_NOW',
  ALERT_MODAL: 'ALERT_MODAL',
  THEME_PREFERENCE: 'THEME_PREFERENCE',
  TOUR: 'TOUR',
};

export const REPORT_SUBMIT_SOURCE = {
  STUDYLIST: '/new/studylist',
  ADVANCE_VIEWER: '/nonXrayAdvanceViewer',
};

export const PATHOLOGY_STATUS = {
  VERIFIED: 'verified',
  ADDED: 'added',
  REJECTED: 'rejected',
};

export const HEADER_SEPERATOR = '2px solid rgb(93 93 93 / 46%)';

export const SHARED_VIEWER = {
  ADVANCE: 0,
  BASIC: 1,
};
export const LIGHT_THEME_ICON_COLOR = '#333333';

export const SPECIALCHAR_UNICODE_REGEX =
  /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F\u200C-\u200F\u2028\u2029\u00AD]/g;

export const THEME_NAME = {
  LIGHT: 'light',
};

export const NO_OF_IMAGES_STATUS = {
  MORE_THAN_ZERO_NO_OF_IMAGES: 1,
  ZERO_NO_OF_IMAGES: 0,
};

export const MAX_FILTER_BADGES_LENGTH =
  process.env.REACT_APP_VDC_PLATFORM == 'true' ||
  process.env.REACT_APP_VDC_PLATFORM == true
    ? 1
    : 5;

export const REINFERECE_ALLOWED_MODALITY = ['DX', 'CR', 'RG', 'SC'];

export const roleAccess = {
  FIRM_ADMIN: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ERRORSTUDY,
    AuthRoutes.ANALYTICS,
    AuthRoutes.ISSUESANDTROUBLESHOOTING,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.RADIOLOGISTLIST,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.MYVIEWUSER,
    AuthRoutes.EDITADMINUSER,
    AuthRoutes.PROVIDERVIEW,
    AuthRoutes.REPORT_TEMPLATE,
    AuthRoutes.REPORTTEMPLATES,
    AuthRoutes.SUPERVISORLIST,
    AuthRoutes.MYADDSUPERVISOR,
    AuthRoutes.MYADDADMINUSER,
    AuthRoutes.MYADDFIRMDOCTOR,
    AuthRoutes.MYADDFIRMADMINUSER,
    AuthRoutes.MYADDFIRMTECHNICIAN,
    AuthRoutes.FIRMTECHNICIANLIST,
    AuthRoutes.FIRMDOCTORLIST,
    AuthRoutes.FIRMADMINUSERLIST,
    AuthRoutes.EDITHEADERTEMPLATE,
    AuthRoutes.ADDHOSPITAL,
    AuthRoutes.ADDTELERADIOLOGYCENTRE,
    AuthRoutes.ADDIMAGINGCENTRE,
    AuthRoutes.EDITHOSPITAL,
    AuthRoutes.MYADDRADIOLOGIST,
    AuthRoutes.ADDREPORTTEMPLATE,
    AuthRoutes.EDITREPORTTEMPLATE,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.ADDRESTRICTIONREPORTTEMPLATE,
    AuthRoutes.TYPISTUSERLIST,
    AuthRoutes.ADDTYPIST,
    AuthRoutes.BILLING_DATA_DOWNLOAD_FORM,
    AuthRoutes.PACSQUEUELIST,
  ],
  RADIOLOGIST: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.REPORT_TEMPLATE,
    AuthRoutes.REPORTTEMPLATES,
    AuthRoutes.ADDREPORTTEMPLATE,
    AuthRoutes.EDITREPORTTEMPLATE,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.PACSQUEUELIST,
    AuthRoutes.HANGINGPROTOCOLLIST,
    AuthRoutes.ADDHANGINGPROTOCOL,
    AuthRoutes.EDITHANGINGPROTOCOL,
    AuthRoutes.VIEWHANGINGPROTOCOL,
    AuthRoutes.MY_STYLES,
    AuthRoutes.ADD_STYLE,
    AuthRoutes.EDIT_STYLE,
  ],
  SUPERVISOR: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.REPORTTEMPLATES,
    AuthRoutes.ADDREPORTTEMPLATE,
    AuthRoutes.EDITREPORTTEMPLATE,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
    AuthRoutes.PACSQUEUELIST,
  ],
  HOSPITAL_DOCTOR: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.EDITHEADERTEMPLATE,
    AuthRoutes.STUDYVIEWER,
    AuthRoutes.NONXRAYADVANCEVIEWER,
    AuthRoutes.PRIORSTUDYVIEWER,
  ],
  HOSPITAL_USER: [
    AuthRoutes.STUDYLIST,
    AuthRoutes.ANALYTICS,
    AuthRoutes.CLIENTLIST,
    AuthRoutes.FIRMDETAILS,
    AuthRoutes.EDITHEADERTEMPLATE,
    AuthRoutes.EDITHOSPITAL,
  ],
};

export const commonAllowedRolesAccess = [
  AuthRoutes.ACCOUNTANDSETTINGS,
  AuthRoutes.ABOUT,
  AuthRoutes.PRIVACY_POLICY,
  AuthRoutes.SHOW_SHARED_REPORT,
  AuthRoutes.SHAREDVIEWER,
  AuthRoutes.FORCECHANGEPWD,
  AuthRoutes.CHANGEPWD,
  AuthRoutes.MOBILEMORE,
];

export const TABS = {
  ACTIVE_BACKGROUND: "#0078D4",
  LIGHT_GLOBAL_GRAY: "#EEE"
}

export const HP_META_TAGS = {
  MODALITY: "0008,0060",
  BODY_PART_EXAMINED: "0018,0015",
  STUDY_DESCRIPTION: "0008,1030",
  SERIES_DESCRIPTION: "0008,103E",
  SERIES_NUMBER: "0020,0011",
  SOP_CLASS_UID: "0008,0016",
  INSTANCE_NUMBER: "0020,0013",
  TRANSFER_SYNTAX_UID: "0002,0010",
  SAMPLES_PER_PIXEL: "0028,0002",
  IMAGE_TYPE: "0008,0008", 
  IMAGE_LATERALITY: "0020,0062", 
  PATIENT_ORIENTATION: "0020,0020",
  VIEW_POSITION: "0018,5101", 
};

export const HP_OPERANDS = {
  EQUALS: "equals",
  NOT_EQUALS: "not_equals",
  CONTAINS: "contains",
  LESS_THAN: "less_than",
  GREATER_THAN: "greater_than",
  LESS_THAN_EQUALS: "less_than_equals",
  GREATER_THAN_EQUALS: "greater_than_equals",
};

export const HP_VIEWPORT_FLIP = {
  ENABLE: "enable",
  DISABLE: "disable",
};

export const HP_VIEWPORT_ALIGNMENT = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center",
};

